import * as _ from 'lodash-es';
import * as d3 from "d3";
import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { doGetPromise } from '../../config/core.httpclient-utils';
import { UserService } from '../../services/core.user.service';
import { GfTranslateService } from '../../services/core.translate.service';
import { GfMetaService } from '../../services/core.meta.service';
import { StateService } from '@uirouter/angular';

@Component({
    selector: 'gf-project-browse',
    template: require('./project-browse.component.html')
})
export class ProjectBrowseComponent implements OnInit {

    protected sortField = 'activity30';
    protected searchText = '';
    protected items: any = false;

    protected activityChartOptions = {
        chart: {
            type: 'lineChart',
            height: 30,
            margin: {
                top: 1,
                right: 1,
                bottom: 1,
                left: 1
            },
            interactive: false,
            showLegend: false,
            x: function (d) {
                return d.x;
            },
            y: function (d) {
                return d.y;
            },
            lines: {
                xScale: d3.time.scale()
            },
            xAxis: {
                // Even though we're not showing the x axis values on the chart,
                // we still need this formatting function for the tooltip display.
                tickFormat: function (d) {
                    var ret = d3.time.format('%Y-%m-%d')(d);
                    return ret;
                }
            },
            showXAxis: false,
            showYAxis: false,
            transitionDuration: 1000
        }
    };

    constructor(
        private stateService: StateService, 
        
        private httpClient: HttpClient,
        private gfTranslateService: GfTranslateService,
        private userService: UserService,
        private metaService: GfMetaService,
        private window: Window
    ) { }
    
    ngOnInit() {
        this.setSeoMetadata();
        this.doFetch();
    };

    /**
     * Emit a sensible generic description and canonical URL for the public
     * project listing page.
     */
    private setSeoMetadata() {
        const siteName = this.gfTranslateService.translate('GForge Next');
        const description = this.gfTranslateService.translate('Browse public projects hosted on {{siteName}}', { siteName: siteName });
        const canonicalUrl = `${this.window.location.origin}/projects`;

        this.metaService.setDescription(description);
        this.metaService.setCanonicalUrl(canonicalUrl);
        this.metaService.setOpenGraph({
            title: this.gfTranslateService.translate('Projects'),
            description: description,
            url: canonicalUrl
        });
    }

    updateSearch = ($ev) => {
        this.stateService.go('.', { q: this.searchText, page_num: 1 });
    };

    updatePage = (params) => {
        this.stateService.go('.', params);
    }

    private doFetch() {
        this.sortField = (_.get(this.stateService.params, 'sort_field', 'activity') == 'activity') ? 'activity30' : 'projectName';
        this.searchText = this.stateService.params?.q;

        this.items = false;

        var params:any = {
            text: this.stateService.params.q,
            page_num: this.stateService.params.page_num,
            page_size: this.stateService.params.page_size,
            sort_field: this.sortField,
            sort_dir: this.sortField == 'activity30' ? 'desc' : 'asc',
            rel: "activity30,member_counts,activity_stats"
        };

        if (! this.userService.session.hasUser()) {
            params.isPublic = true;
        }

        // /api/project
        doGetPromise(this.httpClient, '/api/project', params)
        .then((response) => {
            this.items = _.map(
                _.get(response, 'items', []),
                (p) => {
                    p.rel.chart_data = this.getChartData(_.get(p, 'rel.activity_stats', []));
                    p.rel.activitylevel = this.getActivityLevel(_.get(p, 'activity30', false));
                    return p;
                }
            );
        }, (result) => {
            console.log("Project search failed", result);
            this.items = [];
        });
    }

    private getActivityLevel(activity30) {
        if (activity30 > 5000) return 4;
        if (activity30 > 1000) return 3;
        if (activity30 > 100) return 2;
        if (activity30 > 25) return 1;
        return 0;
    }

    private getChartData(data) {
        const vals = _.map(
            data,
            function(d) {
                var dt = new Date(d.statDate + 'T00:00:00');
                var ticks = dt.getTime() + (dt.getTimezoneOffset() * 60000);
                return {
                    x: new Date(ticks),
                    y: parseInt(d.measure)
                };
            }
        );
        const key = this.gfTranslateService.translate('Project Activity');
        return [{
            values: vals,
            key: key,
            color: 'rgba(152, 223, 138, .5)',
            area: true
        }];
    }
}
